import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeAirportListItem extends SearchModelBase {
    code: string = '';
    usCode: string = '';
    portName: string = '';
    cid: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Airport Name', width: 500, dataIndex: 'portName', defaultColumnFocus : true}),
        XCol.Create({ col: 1, text: 'Code', width: 50, dataIndex: 'code'}),
        XCol.Create({ col: 2, text: 'Custom Code', width: 100, dataIndex: 'usCode'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeAirportListItem.prototype.code, orderByAscending: true };

    public static formatData(data: CodeAirportListItem[]) {
        return data.map((d: CodeAirportListItem) => ({
          ...d,
        }));
    }

}
